import {ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {FeatherIconsComponent} from "@shared/components/feather-icons/feather-icons.component";
import {MatTableModule} from "@angular/material/table";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatRippleModule} from "@angular/material/core";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatTooltipModule} from "@angular/material/tooltip";
import {NgOptimizedImage} from "@angular/common";
import {TableElement, TableExportUtil, UnsubscribeOnDestroyAdapter} from "@shared";
import {PatientHealthEventService} from "@core/http/table-data-services/patientHealthEvent.service";
import {PatientHealthEvent} from "@core/models/PatientHealthEvent";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialog, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {
  PatientHealthEventCreateEditComponent
} from "../patient-health-event-create-edit/patient-health-event-create-edit.component";
import {fromEvent} from "rxjs";
import {
  PatientHealthEventDescriptionComponent
} from "../../../catalogs/catalogs-list-v2/health-events/health-events-list/patient-health-event-description/patient-health-event-description.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {PatientByIdHealthEventService} from "@core/http/table-data-services/patientByIdHealthEvent.service";
import {PatientByIdHealthEventDataSource} from "@core/data-source/PatientByIdHealthEventDataSource";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";

@Component({
  selector: 'app-health-events-by-id-patient',
  standalone: true,
  imports: [
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatCheckboxModule,
    FeatherIconsComponent,
    MatRippleModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    NgOptimizedImage,
    MatDialogContent
  ],
  templateUrl: './health-events-by-id-patient.component.html',
  styleUrl: './health-events-by-id-patient.component.scss'
})
export class HealthEventsByIdPatientComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit {

  displayedColumns = [
    'evento',
    'fecha',
    'descripcion'
  ];

  data?: PatientByIdHealthEventService;
  dataSource!: PatientByIdHealthEventDataSource;
  index?: number;
  healthEvent?: PatientHealthEvent;
  @ViewChild(MatPaginator, {static: true})
  paginator!: MatPaginator;
  @ViewChild(MatSort, {static: true})
  sort!: MatSort;
  @ViewChild('filter', {static: true}) filter?: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<HealthEventsByIdPatientComponent>,
    public httpClient: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    public healthEventService: PatientHealthEventService,
    private cd: ChangeDetectorRef,
    private httpMsgHandler: HttpMesageHandlerService,
    @Inject(MAT_DIALOG_DATA) public dData: {
      title: string,
      idPaciente: string
    },
  ) {
    super();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['nuevo'] === 'true') {
        this.addNew();
        this.router.navigate([], {
          queryParams: {nuevo: null},
          queryParamsHandling: 'merge'
        }).then();
      }
    });
    this.loadData();
    this.cd.detectChanges();
  }

  refresh() {
    this.ngOnInit();
  }

  addNew() {
    this.healthEvent = new PatientHealthEvent({
      descripcion: "",
      eventoDeSalud: 0,
      fecha: "",
      idPaciente: this.dData.idPaciente,
      nombreEvento: "",
      idEventoSalud: ""
    })
    const dialogRef = this.dialog.open(PatientHealthEventCreateEditComponent, {
      data: {
        entity: this.healthEvent,
        action: 'add',
      }
    });

    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result === 1) {
        this.data?.dataChange.value.unshift(
          this.healthEventService.getDialogData()
        );

        setTimeout(() => {
          this.refresh();
          this.refreshTable();
        }, 100);
      }
    });
  }

  public loadData() {
    this.data = new PatientByIdHealthEventService(this.httpClient, this.httpMsgHandler);
    this.dataSource = new PatientByIdHealthEventDataSource(
      this.data,
      this.paginator,
      this.sort,
      this.dData.idPaciente
    );
    this.subs.sink = fromEvent(this.filter?.nativeElement, 'keyup').subscribe(
      () => {
        if (!this.dataSource) {
          return;
        }
        this.dataSource.filter = this.filter?.nativeElement.value;
      }
    );
  }

  exportExcel() {
    const exportData: Partial<TableElement>[] =
      this.dataSource.filteredData.map((x: PatientHealthEvent) => ({
        IdPaciente: x.idPaciente,
        Fecha: x.fecha,
        IdEvento: x.eventoDeSalud,
        Descripcion: x.descripcion,
        Nombre: x.nombreEvento,
      }));
    TableExportUtil.exportToExcel(exportData, 'excel');
  }

  showDescription(row: PatientHealthEvent) {
    this.dialog.open(PatientHealthEventDescriptionComponent, {
      width: '70vw',
      data: {
        data: row
      }
    });
  }

  private refreshTable() {
    this.paginator._changePageSize(this.paginator.pageSize);
    this.cd.detectChanges();
  }
}
